// extracted by mini-css-extract-plugin
export default {"home":"HomeSection_home__Lje3H","home-container":"HomeSection_home-container__9-kUG","dot-pattern":"HomeSection_dot-pattern__wXbmo","home-content":"HomeSection_home-content__7veUA"};